module.exports = __webpack_public_path__ + "static/ated4kids_logo_no_border-842ae5b656ec5e47d5d4c955dc8e9461.png";